import { jsx as _jsx } from "react/jsx-runtime";
import { PurchaseCustomizationPlate, ScrollableContainer, } from '@streamr/tv-ui';
import styled from 'styled-components';
import { BottomLeft, Popup } from '../../utils/popups';
import { usePurchasePopupAnchorElementRef } from '../../utils/purchasePopupAnchor';
import { PurchasePopupRoot } from './PurchasePopup';
export function PurchaseCustomizationPopup({ reject, resolve, product, amount, minAmount, maxAmount, onAmountChange, customMessage, onCustomMessageChange, buyerNickname, }) {
    const [title, subtitle] = product
        ? [
            `Send support to ${product.name}`,
            `Buy a Super Balloon, which directly supports ${product.name}.`,
        ]
        : [undefined, undefined];
    const anchorRef = usePurchasePopupAnchorElementRef();
    return (_jsx(PurchasePopupRoot, { reject: reject, anchorRef: anchorRef, translateFn: BottomLeft, "$alignToSidebar": !!anchorRef, children: _jsx(PopupContentOuter, { children: _jsx(ScrollableContainer, { children: _jsx(PopupContent, { children: _jsx(PurchaseCustomizationPlate, { buyerName: buyerNickname ?? '', title: title, onCloseButtonClick: () => {
                            reject();
                        }, onInfoButtonClick: () => {
                            reject(InfoClickSignal);
                        }, subtitle: subtitle, amount: amount, minAmount: minAmount, maxAmount: maxAmount, onAmountChange: onAmountChange, message: customMessage, onMessageChange: onCustomMessageChange, canSubmit: true, currency: product.currency, onSubmit: ({ amount: priceUnitAmount }) => {
                            if (product) {
                                resolve({ ...product, priceUnitAmount });
                            }
                            else {
                                reject(new Error('Product unavailable'));
                            }
                        } }) }) }) }) }));
}
const PopupContent = styled.div `
    --Plate_FooterMargin: 1rem 0 0;

    padding: 0 1.5rem;
    max-height: var(--PurchaseCustomization_ContentMaxHeight, none);
`;
const PopupContentOuter = styled.div `
    padding: 1.5rem 0;
`;
export const purchaseCustomizationPopup = Popup.create(PurchaseCustomizationPopup);
export const InfoClickSignal = Symbol('InfoClickSignal');
